/* ───────────────────────────────────────────
   NEON SKIES — NAV PREDICTIVE SEARCH
   Lightweight autocomplete for the nav search inputs.
   Uses /search/suggest.json (products, prefix: last, limit 6).
   Vanilla JS, self-contained, fails silent on any error.
   ─────────────────────────────────────────── */
'use strict';
(function () {
  var DEBOUNCE = 250;
  var MIN_CHARS = 2;
  var LIMIT = 6;

  (function injectStyle() {
    if (document.getElementById('nav-sug-style')) return;
    var s = document.createElement('style');
    s.id = 'nav-sug-style';
    s.textContent =
      '.nav-sug{position:absolute;top:calc(100% + 6px);right:0;min-width:280px;max-width:340px;background:var(--cream,#fff);border:1px solid var(--border,#ddd);border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,.14);z-index:1200;overflow:hidden;display:none;}' +
      '.nav-sug.is-open{display:block;}' +
      '.nav-sug-it{display:flex;align-items:center;gap:10px;padding:8px 10px;text-decoration:none;color:var(--purple,#333);font-size:.85rem;line-height:1.25;}' +
      '.nav-sug-it.is-hl{background:rgba(0,0,0,.07);}' +
      '.nav-sug-img{width:40px;height:40px;object-fit:cover;border-radius:6px;flex:0 0 40px;background:rgba(0,0,0,.05);}' +
      '.nav-sug-t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}' +
      '.nav-sug-p{opacity:.75;white-space:nowrap;font-variant-numeric:tabular-nums;}';
    document.head.appendChild(s);
  })();

  function attach(input) {
    if (input.__sugInit) return;
    input.__sugInit = true;

    // Climb past ancestors that clip (overflow != visible) so the dropdown
    // is not cut off by animated/hidden containers like the expanding form.
    var wrap = input.parentElement || input.form;
    if (!wrap) return;
    try {
      var hops = 0;
      while (wrap.parentElement && hops < 4 &&
             window.getComputedStyle(wrap).overflow !== 'visible') {
        wrap = wrap.parentElement;
        hops++;
      }
      if (window.getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    } catch (e) {}

    var box = document.createElement('div');
    box.className = 'nav-sug';
    wrap.appendChild(box);

    var timer = null, hl = -1, links = [], open = false;

    function hide() {
      open = false; hl = -1; links = [];
      box.classList.remove('is-open');
      box.innerHTML = '';
    }
    function setHl(i) {
      hl = i;
      links.forEach(function (el, j) { el.classList.toggle('is-hl', j === i); });
    }

    function render(products) {
      box.innerHTML = '';
      links = []; hl = -1;
      if (!products || !products.length) { hide(); return; }
      products.forEach(function (p) {
        if (!p || !p.url) return;
        var a = document.createElement('a');
        a.className = 'nav-sug-it';
        a.href = p.url;
        var img = document.createElement('img');
        img.className = 'nav-sug-img';
        img.width = 40; img.height = 40; img.alt = '';
        img.loading = 'lazy';
        var src = (p.featured_image && p.featured_image.url) || p.image || '';
        if (src) img.src = src;
        var t = document.createElement('span');
        t.className = 'nav-sug-t';
        t.textContent = p.title || '';
        var pr = document.createElement('span');
        pr.className = 'nav-sug-p';
        pr.textContent = p.price != null ? String(p.price) : '';
        a.appendChild(img); a.appendChild(t); a.appendChild(pr);
        a.addEventListener('mouseenter', function () { setHl(links.indexOf(a)); });
        box.appendChild(a);
        links.push(a);
      });
      if (!links.length) { hide(); return; }
      open = true;
      box.classList.add('is-open');
    }

    function query(term) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[options][prefix]=last&resources[options][unavailable_products]=hide&resources[limit]=' + LIMIT;
      fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('suggest failed'); return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== term) return; // stale response
          var prods = data && data.resources && data.resources.results && data.resources.results.products;
          render(prods || []);
        })
        .catch(function () { hide(); });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);
      if (term.length < MIN_CHARS) { hide(); return; }
      timer = setTimeout(function () { query(term); }, DEBOUNCE);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); return; }
      if (!open || !links.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setHl((hl + 1) % links.length);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setHl((hl - 1 + links.length) % links.length);
      } else if (e.key === 'Enter') {
        if (hl >= 0 && links[hl]) {
          e.preventDefault();
          window.location.href = links[hl].href;
        }
        // no highlight: let the form submit to /search normally
      }
    });

    // The search page ignores options[prefix] on this store, so give the
    // submitted query the same prefix flexibility with a trailing wildcard.
    if (input.form && !input.form.__sugSubmit) {
      input.form.__sugSubmit = true;
      input.form.addEventListener('submit', function () {
        try {
          var v = input.value.trim();
          if (v.length >= MIN_CHARS &&
              v.slice(-1) !== '*' &&
              v.indexOf('"') === -1) {
            input.value = v + '*';
          }
        } catch (e) {}
      });
    }

    // Delay so a click on a suggestion link still lands before we hide.
    input.addEventListener('blur', function () {
      setTimeout(hide, 180);
    });

    document.addEventListener('pointerdown', function (e) {
      if (open && !wrap.contains(e.target)) hide();
    });
  }

  function initAll() {
    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
